/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef, Fragment } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';
import { render } from 'storyblok-rich-text-react-renderer';

import FluidImage from 'components/fluidImage';
import Toggle from 'components/shared/toggle/toggle';

const displayStaticMap = (blok) => {
  const formattedAddress = blok.address.replace(/\n/g, ', ');
  const uri = `https://maps.googleapis.com/maps/api/staticmap?center=${formattedAddress}&zoom=16&scale=2&size=600x400&maptype=roadmap&key=AIzaSyAXX-4jJaso2ttxIpC8z628n5qPR32xdcs&map_id=85ba1de35be18e76&&markers=${formattedAddress}`;
  const encodedMapUri = encodeURI(uri);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${formattedAddress}`;
  return {
    encode: encodedMapUri,
    url: mapUrl,
    image: { ...blok.image },
  };
};

const AddressBlock = ({ blok }) => {
  const activeMapRef = useRef(null);
  const mapHolderRef = useRef(null);
  const [map, setMap] = useState(null);
  const renderTextLeft = render(blok.text_left);
  const renderTextRight = render(blok.text_right);

  useEffect(() => {
    activeMapRef.current = document.querySelector('[data-map-active="true"]');
    if (activeMapRef.current) {
      setMap({
        url: activeMapRef.current.dataset.mapUrl,
        image: { filename: activeMapRef.current.dataset.map },
      });
    }
  }, []);

  const displayMapHandler = (target) => {
    const mapHolder = target.parentElement.nextSibling;
    document.querySelectorAll('[data-map-active="true"]').forEach((el) => {
      el.setAttribute('data-map-active', 'false');
    });
    document.querySelectorAll('.map-title').forEach((el) => {
      if (el !== target.querySelector('.map-title')) {
        el.classList.remove('menu-animate');
      }
    });
    document.querySelectorAll('.map-holder').forEach((el) => {
      if (el !== mapHolder) {
        el.classList.add('mobile:hidden');
      }
    });
    document.querySelectorAll('.address-item').forEach((el) => {
      if (el !== mapHolder.nextSibling) {
        el.classList.remove('mobile:col-span-full');
      }
    });
    mapHolder.setAttribute('data-map-show', 'true');
    mapHolder.classList.toggle('mobile:hidden');
    mapHolder.nextSibling?.classList.toggle('mobile:col-span-full');
    target.setAttribute('data-map-active', 'true');
    if (mapHolder.classList.contains('mobile:hidden')) {
      if (target.querySelector('.map-title')) {
        target.querySelector('.map-title').classList.remove('menu-animate');
      }
    } else if (target.querySelector('.map-title')) {
        target.querySelector('.map-title').classList.add('menu-animate');
      }
    setMap({
      url: target.dataset.mapUrl,
      image: { filename: target.dataset.map },
    });
  };

  useEffect(() => {
    if (blok.animate) {
      sal({ threshold: 0.25 });
    }
  }, [blok.animate]);

  const isAnimate = blok.animate;

  return (
    <>
      <div
        className="container grid gap-5 overflow-hidden py-7 lg:grid-cols-2 lg:py-8 xl:py-10 mobile:pb-0"
        {...(isAnimate
          ? {
              'data-sal': 'slide-up',
              'data-sal-duration': '1000',
              'data-sal-delay': '0',
              'data-sal-easing': 'ease',
            }
          : {})}
      >
        <div className="grid grid-cols-2 gap-x-5">
          {blok.blocks.map((blok, index) => {
            const { url } = displayStaticMap(blok);

            return (
              <Fragment key={blok._uid}>
                <div className="address-item flex flex-col justify-between gap-4 pb-10 lg:gap-5 lg:pb-8 xl:relative xl:gap-8 xl:pb-10">
                  <div
                    className="cursor-pointer space-y-4 lg:space-y-5 xl:space-y-8"
                    data-map={blok?.image?.filename}
                    data-map-url={url}
                    data-map-active={index === 0 ? 'true' : 'false'}
                    ref={activeMapRef}
                    onClick={(e) => displayMapHandler(e.target.parentElement)}
                  >
                    <div className="map-title menu-animate text-sm font-semibold lg:text-base xl:text-[1.375rem]">
                      {blok.title}
                    </div>
                    <div className="relative flex flex-col lg:min-h-[8rem] xl:min-h-[10.5rem]">
                      <pre className="block flex-1 font-sans text-sm !leading-[1.12] lg:text-lg xl:text-2xl">
                        {blok.address}
                      </pre>
                      <div className="bottom-0 flex-1 text-sm lg:absolute lg:text-lg xl:text-2xl mobile:pt-6">
                        {blok.phone}
                      </div>
                    </div>
                  </div>

                  {blok.po_box ? (
                    <div>
                      <Toggle text="P.O Box" buttonClassname="gap-4 lg:gap-6" className="pb-6">
                        <pre className="block font-sans text-sm !leading-[1.12] lg:text-lg xl:text-2xl">
                          {blok.po_box}
                        </pre>
                      </Toggle>
                    </div>
                  ) : (
                    <div className="invisible text-left text-sm font-semibold leading-[1.15] lg:text-base xl:text-[1.375rem]">
                      No P.O Box
                    </div>
                  )}
                </div>
                {map && (
                  <div
                    className="map-holder col-span-full pb-16 lg:hidden mobile:hidden"
                    ref={mapHolderRef}
                    data-map-show="false"
                  >
                    <a href={map.url} target="_blank" rel="noreferrer">
                      <FluidImage
                        image={map.image}
                        className="h-full w-full object-cover lg:aspect-[795/800]"
                      />
                    </a>
                  </div>
                )}
              </Fragment>
            );
          })}
        </div>
        {map && (
          <div className="map-holder hidden pb-7 lg:block lg:gap-5 lg:pb-8 xl:pb-10">
            <a href={map.url} target="_blank" rel="noreferrer">
              <FluidImage
                image={map.image}
                className="h-full w-full object-cover lg:aspect-[795/800]"
              />
            </a>
          </div>
        )}
      </div>
      <article
        className="container grid gap-12 py-7 lg:grid-cols-2 lg:gap-5 lg:py-8 xl:py-10 mobile:pb-5 mobile:pt-2"
        {...(isAnimate
          ? {
              'data-sal': 'slide-up',
              'data-sal-duration': '1000',
              'data-sal-delay': '0',
              'data-sal-easing': 'ease',
            }
          : {})}
      >
        {renderTextLeft && (
          <div className="flex flex-col justify-between mobile:order-1">
            <div className="prose text-sm !leading-normal lg:text-lg lg:!leading-[1.10] xl:text-2xl">
              {renderTextLeft}
            </div>
          </div>
        )}
        {renderTextRight && (
          <div className="space-y-4 lg:space-y-6 ">
            <div className="prose text-sm  !leading-normal lg:text-lg lg:!leading-[1.10] xl:text-2xl">
              {renderTextRight}
            </div>
          </div>
        )}
      </article>
    </>
  );
};

export default AddressBlock;

AddressBlock.propTypes = {
  blok: PropTypes.object.isRequired,
};
